import { ServiceResult } from '../models';
import {
  CreateRecipeIngredientCategoryRequest,
  DeleteRecipeIngredientCategoryRequest,
  RecipeIngredientCategory,
  UpdateRecipeIngredientCategoryRequest,
} from '../models/recipe-ingredient-category.models';
import ApiService from './api-service';

class RecipeIngredientCategoryService extends ApiService {
  private static classInstance: RecipeIngredientCategoryService;

  private constructor() {
    super('RecipeIngredientCategory');
  }

  public static getInstance(): RecipeIngredientCategoryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeIngredientCategoryService();
    }
    return this.classInstance;
  }

  public getRecipeIngredientCategory(recipeIngredientCategoryId: string): ServiceResult<RecipeIngredientCategory> {
    return this.get(
      `${this.baseUrl}/GetRecipeIngredientCategory?recipeIngredientCategoryId=${recipeIngredientCategoryId}`
    );
  }

  public getRecipeIngredientCategorys(customerId: string): ServiceResult<RecipeIngredientCategory[]> {
    return this.get(`${this.baseUrl}/GetRecipeIngredientCategorys?customerId=${customerId}`);
  }

  public createRecipeIngredientCategory(
    request: CreateRecipeIngredientCategoryRequest
  ): ServiceResult<RecipeIngredientCategory> {
    return this.post(`${this.baseUrl}/CreateRecipeIngredientCategory`, request);
  }

  public updateRecipeIngredientCategory(
    request: UpdateRecipeIngredientCategoryRequest
  ): ServiceResult<RecipeIngredientCategory> {
    return this.post(`${this.baseUrl}/UpdateRecipeIngredientCategory`, request);
  }

  public deleteRecipeIngredientCategory(request: DeleteRecipeIngredientCategoryRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeIngredientCategory`, request);
  }
}

export default RecipeIngredientCategoryService;
